import { colors } from 'styles/colors';

export const avatarBgColorPallets = [
  colors.avatar.background,
  colors.avatar.bgColor,
  colors.background.avatarBackgound,
  colors.avatar.avatarBgColor2,
  colors.avatar.avatarBgColor3,
];

export const avatarFontColorPallets = [
  colors.avatar.avatarFontColor1,
  colors.avatar.borderColor,
  colors.avatar.textColor1,
  colors.avatar.textColor2,
  colors.avatar.textColor2,
];

const getProfileIndexNumber = (alphabet: string) => {
  const charCode = alphabet?.toUpperCase()?.charCodeAt(0);
  return Math.floor(
    (isNaN(charCode) ? 0 : charCode - 65) % avatarBgColorPallets.length
  );
};

export const getAvatarStyleByIndex = (index: number) => ({
  backgroundColor:
    avatarBgColorPallets[Math.floor(index % avatarBgColorPallets.length)],
  color: `${
    avatarFontColorPallets[Math.floor(index % avatarFontColorPallets.length)]
  } !important`,
});

export const getAvatarStyleByAlphabet = (name: string) => ({
  backgroundColor: avatarBgColorPallets[getProfileIndexNumber(name)],
  color: `${avatarFontColorPallets[getProfileIndexNumber(name)]} !important`,
});
